export const curriculumNames: Record<string, string> = {
  'Australian Curriculum V9': 'AUS V9',
  'Australian Curriculum V8': 'AUS V8',
  'Australian Curriculum Categories': 'AUS V8',
  'New South Wales Curriculum': 'NSW',
  'Victorian Curriculum': 'VIC',
  'Common Core State Standards': 'CCSS',
  TEKS: 'TEKS',
  'National Curriculum In England': 'NC',
};
export default curriculumNames;
